// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Δοκιμάστε ξανά χρησιμοποιώντας μια ολοκληρωμένη ημερομηνία όπως: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Ομάδα',
  chart_labelSeries: () => 'Σειρά',
  chart_labelValue: () => 'Τιμή',
  checkboxSet_requiredMessageDetail: () => 'Απαιτείται',
  checkbox_requiredMessageDetail: () => 'Απαιτείται',
  close: () => 'Κλείσιμο',
  collection_noData: () => 'Δεν υπάρχουν δεδομένα για εμφάνιση.',
  collection_selectAllRows: () => 'Επιλέξτε όλες τις γραμμές',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Επιλογή σειράς ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Χωρίς δυνατότητα ταξινόμησης',
  collection_sortEnabled: () => 'Με δυνατότητα ταξινόμησης',
  confirmation: () => 'Επιβεβαίωση',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' από ' + p['totalCount'],
  dataVisualization_noData: () => 'Δεν υπάρχουν δεδομένα για εμφάνιση',
  dataVisualization_stateSelected: () => 'Επιλεγμένο',
  dataVisualization_stateUnselected: () => 'Μη επιλεγμένο',
  error: () => 'Σφάλμα',
  expandableList_expandCollapseInstructionText: () =>
    'Χρησιμοποιήστε τα πλήκτρα-βέλη για ανάπτυξη και σύμπτυξη',
  expandableList_groupCollapse: () => 'Συμπτύχθηκε',
  expandableList_groupExpand: () => 'Αναπτύχθηκε',
  filePicker_addFiles: () => 'Προσθήκη αρχείων',
  filePicker_dropzonePrimaryText: () => 'Μεταφορά και απόθεση',
  filePicker_dropzoneSecondaryText: () =>
    'Επιλέξτε ένα αρχείο ή πραγματοποιήστε απόθεση ενός αρχείου εδώ',
  filePicker_dropzoneSecondaryTextMultiple: () =>
    'Επιλέξτε αρχεία ή πραγματοποιήστε απόθεση αρχείων εδώ',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Δεν μπορείτε να αποστείλετε αρχεία τύπου: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Κάντε αποστολή ενός αρχείου τη φορά',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Δεν μπορείτε να αποστείλετε αρχεία τύπου ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'άγνωστος',
  formControl_clear: () => 'Εκκαθάριση',
  formControl_day: () => 'Ημέρα',
  formControl_helpAvailable: () => 'Διατίθεται βοήθεια',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Έχετε συμπληρώσει το όριο ' +
    (({ one: '1 χαρακτήρα' } as Partial<Record<Intl.LDMLPluralRule, string>>)[
      new Intl.PluralRules('el').select(p['CHARACTER_LIMIT'])
    ] || new Intl.NumberFormat('el').format(p['CHARACTER_LIMIT']) + ' χαρακτήρων') +
    '.',
  formControl_loading: () => 'Φόρτωση',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Υπέρβαση μέγιστου μήκους ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Απομένουν ' + p['CHARACTER_COUNT'] + ' χαρακτήρες.',
  formControl_month: () => 'Μήνας',
  formControl_readOnly: () => 'Μόνο για ανάγνωση',
  formControl_requiredMessageDetail: () => 'Καταχωρίστε μια τιμή.',
  formControl_year: () => 'Έτος',
  gantt_labelDate: () => 'Ημερομηνία',
  gantt_labelEnd: () => 'Λήξη',
  gantt_labelLabel: () => 'Ετικέτα',
  gantt_labelRow: () => 'Σειρά',
  gantt_labelStart: () => 'Έναρξη',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Δεν βρέθηκε τμήμα που να συμφωνεί.',
  indexer_keyboardInstructionText: () => 'Πατήστε το πλήκτρο Εnter για να επιλέξετε τιμή.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Μεταξύ ' + p['FROM_SECTION'] + ' και ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Πατήστε δύο φορές και κρατήστε πατημένο για να εισέλθετε στη λειτουργία κινήσεων και έπειτα σύρετε προς τα επάνω ή προς τα κάτω για να προσαρμόσετε την τιμή.',
  info: () => 'Πληροφορίες',
  inputDateMask_date_cleared: () => 'Έγινε εκκαθάριση ημερομηνίας',
  inputDateMask_dayPlaceholder: () => 'ηη',
  inputDateMask_empty_segment: () => 'Κενό',
  inputDateMask_monthPlaceholder: () => 'μμ',
  inputDateMask_yearPlaceholder: () => 'εεεε',
  inputNumber_converterParseError: () => 'Καταχωρίστε έναν αριθμό.',
  inputNumber_decrease: () => 'Μείωση',
  inputNumber_increase: () => 'Αύξηση',
  inputPassword_hidden: () => 'Ο κωδικός πρόσβασης κρύφτηκε',
  inputPassword_hide: () => 'Απόκρυψη κωδικού πρόσβασης',
  inputPassword_show: () => 'Εμφ. κωδ. πρόσβασης',
  list_suggestion: () => 'Πρόταση',
  messageToast_allMessagesClosed: () => 'Όλες οι αναδυόμενες ειδοποιήσεις έκλεισαν.',
  message_close: () => 'Κλείσιμο',
  message_confirmation: () => 'Επιτυχία',
  message_error: () => 'Σφάλμα',
  message_info: () => 'Πληροφορίες',
  message_navigationFromMessagesRegion: () =>
    'Περιοχή εισαγωγής μηνυμάτων. Πατήστε το F6 για πλοήγηση σε προηγούμενο εστιασμένο στοιχείο.',
  message_navigationToMessagesRegion: () =>
    'Η περιοχή μηνυμάτων έχει νέα μηνύματα. Πατήστε το F6 για πλοήγηση στην πιο πρόσφατη περιοχή μηνυμάτων.',
  message_warning: () => 'Προειδοποίηση',
  noData_message: () => 'Δεν υπάρχουν στοιχεία για εμφάνιση',
  overflowItemLabel: () => 'Περισσότερες καρτέλες',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Σε εξέλιξη',
  radio_helpForRadio: () => 'Βοήθεια για το κουμπί επιλογής',
  radio_requiredMessageDetail: () => 'Επιλέξτε μια τιμή.',
  selectMultiple_apply: () => 'Εφαρμογή',
  selectMultiple_back: () => 'Πίσω',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Πατήστε Backspace ή Delete για να καταργηθεί η επιλεγμένη τιμή.',
  selectMultiple_selectedValues: () => 'Επιλεγμένες τιμές',
  selectMultiple_showSelectedValues: () => 'Εμφάνιση μόνο των επιλεγμένων τιμών.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Επιλέχθηκαν ' + p['VALUE_COUNT'] + ' τιμές.',
  select_addToList: () => 'Προσθήκη σε λίστα',
  select_addToListAvailable: () => 'Η προσθήκη σε λίστα είναι διαθέσιμη',
  select_moreSearchOptions: () => 'Περισσότερες επιλογές αναζήτησης',
  select_moreSearchOptionsAvailable: () => 'Διατίθενται περισσότερες επιλογές αναζήτησης',
  select_noMatchesFound: () => 'Δεν βρέθηκαν αποτελέσματα.',
  select_oneMatchFound: () => 'Βρέθηκε ένα αποτέλεσμα',
  select_requiredMessageDetail: () => 'Επιλέξτε μια τιμή.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Βρέθηκαν ' + p['TOTAL_SIZE'] + ' αποτελέσματα',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Βρέθηκαν ' + p['TOTAL_SIZE'] + ' ή περισσότερα αποτελέσματα',
  selector_selected: () => 'Ενεργοποιήθηκε το πλαίσιο επιλογής',
  selector_unselected: () => 'Το πλαίσιο επιλογής δεν είναι ενεργοποιημένο',
  tabBarNavigationList_removeCueText: () => 'Με δυνατότητα κατάργησης',
  timeComponent_tooltipZoomIn: () => 'Μεγέθυνση',
  timeComponent_tooltipZoomOut: () => 'Σμίκρυνση',
  train_current: () => 'Τρέχον',
  train_message_type: () => 'Τύπος μηνύματος',
  train_not_visited: () => 'Χωρίς επίσκεψη',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Βήμα ' + p['currentStep'] + ' από ' + p['numberOfSteps'],
  train_visited: () => 'Με επίσκεψη',
  userAssistance_learnMore: () => 'Μάθετε περισσότερα',
  userAssistance_required: () => 'Απαιτείται',
  viz_drillable: () => 'Με δυνατότητα ανάπτυξης/σύμπτυξης',
  warn: () => 'Προειδοποίηση'
};
export default bundle;
